export { PatientDevicesTab } from './PatientDevicesTab';
export { PatientMedicalAidTab } from './PatientMedicalAidTab';
export { PatientMedicalAidUpdateTab } from './PatientMedicalAidUpdateTab';
export { PatientNextOfKinTab } from './PatientNextOfKinTab';
export { PatientProfileTab } from './PatientProfileTab';
